const RateGetter = {
  rates: state => state.rates
};

export default RateGetter;
